import {Component, inject, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BaseModalComponent} from '../base-modal/base-modal.component';
import {RecordData} from '../../../types/records-table.types';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ColumnParamsStateService} from "../../../services/table-services/column-params-state.service";
import {repeatsModalName, repeatsTable} from "./configs/repeats-modal-config";
import {WrapperElementSizeStateService} from "../../../services/table-services/wrapper-element-size-state.service";
import {RepeatsTableComponent} from "./components/repeats-table/repeats-table.component";
import {LoaderComponent} from "../../../../shared/components/loader/loader.component";

@Component({
  selector: 'app-repeats-modal',
  standalone: true,
  imports: [
    CommonModule,
    BaseModalComponent,
    RepeatsTableComponent,
    LoaderComponent
  ],
  templateUrl: './repeats-modal.component.html',
  styleUrls: [
    '../base-modal/base-modal.component.scss',
    './repeats-modal.component.scss'
  ]
})
export class RepeatsModalComponent extends BaseModalComponent {
  public recordData = inject<{ recordData: RecordData }>(MAT_DIALOG_DATA)
  private columnParamsStateService: ColumnParamsStateService = inject(ColumnParamsStateService);
  private wrapperElementSizeStateService: WrapperElementSizeStateService = inject(WrapperElementSizeStateService);

  public readonly repeatsTable = repeatsTable;
  public recordsListRecordTableData = signal<Array<RecordData>>([]);
  public calendarListRecordTableData = signal<Array<RecordData>>([]);

  public override async ngOnInit(): Promise<void> {
    super.ngOnInit();
    this.loadingService.setIsLoadingState(true);
    this.modalStatesService.openModal(repeatsModalName);
    await this.getRecordsListRecordTableDataData(+this.recordData.recordData.id)
      .then((data) => this.recordsListRecordTableData.set(data));
    await this.getCalendarListRecordTableDataData(+this.recordData.recordData.id)
      .then((data) => this.calendarListRecordTableData.set(data))
      .finally(() => this.loadingService.setIsLoadingState(false));
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(repeatsModalName);
    repeatsTable.forEach(record => {
      this.columnParamsStateService.resetTableColumnParamsState(record.key);
      this.wrapperElementSizeStateService.resetSpecificWrapperElementSize(record.key);
    });
  }

  public getTableData(key: string): Array<RecordData> {
    return key === 'record-lists-repeats' ?
      this.recordsListRecordTableData() :
      this.calendarListRecordTableData();
  }

  private getRecordsListRecordTableDataData(recordId: number): Promise<Array<RecordData>> {
    return new Promise(resolve => {
      this.repeatsModalService.getRepeatsForRecordsList(recordId).subscribe({
        next: (recordTableData: Array<RecordData>) => resolve(recordTableData)
      });
    });
  }

  private getCalendarListRecordTableDataData(recordId: number): Promise<Array<RecordData>> {
    return new Promise(resolve => {
      this.repeatsModalService.getRepeatsForCalendarList(recordId).subscribe({
        next: (recordTableData: Array<RecordData>) => resolve(recordTableData)
      });
    });
  }
}
